// extracted by mini-css-extract-plugin
export default {"slides_box":"index_slides_box_iAnQY","tip":"index_tip_eaeLN"};